import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

// This component can wrap sections that need specific dark mode styling
const DarkModeWrapper = ({ children, className = '', sectionName = '' }) => {
  const { isDark } = useTheme();

  // Base styles for different section types in dark mode
  const darkModeStyles = {
    // Home page sections
    'core-technologies': isDark ? 'bg-slate-900 text-slate-100' : 'bg-white',
    'recent-highlights': isDark ? 'bg-slate-900 text-slate-100' : 'bg-white',
    'testimonial': isDark ? 'bg-gradient-to-br from-slate-900 to-slate-800' : 'bg-gradient-to-br from-surface to-muted',
    
    // About page sections
    'timeline': isDark ? 'bg-slate-900 text-slate-100' : 'bg-white',
    'development-philosophy': isDark ? 'bg-slate-900 text-slate-100' : 'bg-white',
    'student-to-engineer': isDark ? 'bg-slate-900 text-slate-100' : 'bg-white',
    'community': isDark ? 'bg-slate-900 text-slate-100' : 'bg-white',
    'resources': isDark ? 'bg-slate-900 text-slate-100' : 'bg-white',
    
    // Experience page sections
    'career-journey': isDark ? 'bg-slate-900 text-slate-100' : 'bg-white',
    'skills-evolution': isDark ? 'bg-slate-900 text-slate-100' : 'bg-white',
    
    // Contact page sections
    'connect': isDark ? 'bg-slate-900 text-slate-100' : 'bg-white',
    'availability': isDark ? 'bg-slate-900 text-slate-100' : 'bg-white',
    
    // Default fallback
    'default': isDark ? 'bg-slate-900 text-slate-100' : ''
  };

  // Get the appropriate styles or use default
  const sectionStyle = darkModeStyles[sectionName] || darkModeStyles['default'];
  
  return (
    <div className={`${sectionStyle} ${className}`}>
      {children}
    </div>
  );
};

export default DarkModeWrapper; 